import { BaseObj } from '../types/baseObj';

export const PAGINATION_DEFAULT_SIZE = 10;
export const PAGINATION_DEFAULT_PAGE = 0;
export const PAGINATION_SIZE_OPTIONS = [10, 20, 50, 100];

export const MODAL_PAGINATION_PAGE_NAMESPACE = 'modalPage';
export const MODAL_PAGINATION_SIZE_NAMESPACE = 'modalSize';

export const initialPaginatedState: BaseObj = {
  page: PAGINATION_DEFAULT_PAGE,
  size: PAGINATION_DEFAULT_SIZE
};